import React from 'react';

/**
 * The four filter squares, task: Home screen redesign (2026-09-08).
 * Replaces the old All / Pending / Accepted / Saved / Declined pill row
 * entirely: one set of controls for the list below, not two.
 *
 * Booked replaces Declined on purpose: it is the outcome that actually
 * matters, and the Zoom Scheduler webhook (CLAUDE.md section 11) already
 * populates meeting_booked automatically, unlike the old declined status,
 * which nothing in the app ever set.
 *
 * Pending/Accepted/Declined as status VALUES are retired from this screen
 * here, not from the database: those columns stay, but they described a
 * confirmed-meeting flow that never ran in production (CLAUDE.md section
 * 5/6), so Captured/Pending/Sent/Booked are new, real definitions, computed
 * in Home.jsx from what actually happened to a contact, not the old status
 * column.
 */
const SQUARES = [
  { key: 'captured', label: 'Captured' },
  { key: 'pending', label: 'Pending' },
  { key: 'sent', label: 'Sent' },
  { key: 'booked', label: 'Booked' },
];

export default function StatSquares({ counts, active, onChange }) {
  return (
    <div className="grid grid-cols-4 gap-2 mb-5">
      {SQUARES.map(({ key, label }) => {
        const isActive = active === key;
        return (
          <button
            key={key}
            type="button"
            onClick={() => onChange(key)}
            className={`rounded-xl py-3 px-1 text-center transition-colors ${
              isActive
                ? 'bg-accent text-accent-foreground shadow-sm'
                : 'bg-card border border-border text-foreground hover:bg-secondary/40'
            }`}
          >
            <p className="text-xl font-bold leading-none">{counts[key] ?? 0}</p>
            <p className={`text-xs font-medium mt-1 ${isActive ? 'text-accent-foreground/80' : 'text-muted-foreground'}`}>
              {label}
            </p>
          </button>
        );
      })}
    </div>
  );
}
